module.exports = __webpack_public_path__ + "media/images/logo-a5a9112c42b47a590882ae74efa0290c.svg";